/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-29 19:45:19
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-16 11:38:34
 */
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Modal, notification } from "antd";
import { TableRowSelection } from "antd/lib/table/interface";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootDispatch } from "../../app/store";
import {
  EditableList,
} from "../../compnents/list/EditableList";
import { QingdouParams } from "../../services/qingdou";
import { ModalColumnsOne, ModalColumnsTwo } from "./columns";
import { ModalQuery } from "./Modalquery";
import styles from "./Qingdou.module.css";
import {
  changeRow,
  getQingdou,
  saveQingdouAsync,
  selectQingdouCurrent,
  selectQingdouData,
  selectQingdouFlag,
  selectQingdouTotal,
  setQingdouCurrent,
  setQingdouData,
} from "./QingdouSlice";
import { Checks } from "../../models/setting";
import { selectSettings } from "../user/setting/settingSlice";

export const QingDouModule = (props: {
  detail: any;
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>();

  const total = useSelector(selectQingdouTotal);

  const flag = useSelector(selectQingdouFlag);

  const current = useSelector(selectQingdouCurrent);

  const data = useSelector(selectQingdouData);

  const settings = useSelector(selectSettings);

  const [queries, setQueries] = useState<QingdouParams>({
    count: 20,
  });

  const [size, setSize] = useState(10);

  const [rowkey, setRowkey] = useState<any[]>([]);

  const [ids, setIds] = useState<any>([]);

  // 新老目录展示方式 (老目录没有区分药品类别/无型号) name + '/' + tenantSupplierName + '/' + packSpec + '/' + doseCategory
 const getProcuctInfo = (item: any, settings: any) => {
  const materialsCategory = item.materialsCategory
  const name = item.name ? item.name : '-'
  const packSpec = item.packSpec ? item.packSpec : '-'
  const spec = item.spec ? item.spec : '-'
  const model = item.model ?  '/' + item.model : ''
  const doseCategory = item.doseCategory ? item.doseCategory : '-'
  const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'

  if (settings?.[Checks.MLKG] == 1) {
    if (materialsCategory == '0') {
      // 生产厂家 + 包装规格 + 剂型 
      return  name + '/' + tenantSupplierName + '/' + packSpec + '/' + doseCategory
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 生产厂家 + 包装规格 + 型号
      return  name + '/' + tenantSupplierName + '/' + packSpec + model
    } else {
      // 生产厂家 + 包装规格 
      return name + '/' +  tenantSupplierName + '/' + packSpec
    }
  } else {
    if (materialsCategory == '0') {
      // 生产厂家 + 规格 + 剂型 
      return  name + '/' + tenantSupplierName + '/' + spec + '/' + doseCategory
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 生产厂家 + 规格 + 型号
      return  name + '/' + tenantSupplierName + '/' + spec + model
    } else {
      // 生产厂家 + 规格 
      return name + '/' + tenantSupplierName + '/' + spec
    }
  }
}
  const handleChange = (prev: any, next: any) => {
    const newdata = {
      ...prev,
      totalPrice: 0,
      productInfo: getProcuctInfo(prev, settings),
      targetInventoryLedgerId: next?.targetInventoryLedgerId,
    };
    setRowkey(newdata)

    if (rowkey.length) {
      setRowkey(
        Array.from(rowkey).map((v: any) => {
          return {
            ...newdata,
            tenantInventoryReceiptsId: newdata?.tenantInventoryLedgerId,
          }
        })
      );
    }
    dispatch(
      changeRow(
        data.map((v: any) =>
          v?.tenantInventoryLedgerId === newdata?.tenantInventoryLedgerId
            ? newdata
            : { ...v }
        )
      )
    );
  };

  useEffect(() => {
    setIds([]);
    if (props.visible) {
      dispatch(
        getQingdou({
          storehouseId: props.detail.storehouseId,
          count: 20,
          current,
          size,
          flag,
          tenantInventoryReceiptsId: props.detail.id,
          ...queries,
        })
      );
    } else {
      dispatch(setQingdouData([]))
    }
  }, [props.visible, queries, size, current]);

  return (
    <Modal
      visible={props.visible}
      title={flag === 1 ? "添加中药清斗" : "添加中药装斗"}
      okText="确认"
      cancelText="取消"
      className={styles.Modal}
      bodyStyle={{ height: "670px", padding: '20px' }}
      onOk={() => {
        props.onOk();
        setQueries({ count: 20 });
      }}
      onCancel={() => {
        props.onCancel();
        setQueries({ count: 20 });
      }}
      footer={null}
    >
      <ModalQuery
        value={queries}
        onValueChange={(v) => {
          setQueries(v);
        }}
        addSelectLine={() => {
          if (!rowkey.length) {
            notification.error({
              message: "请选择装斗或清斗药品",
              duration: 3,
            });
            return
          }
          if (flag === 1) {
            dispatch(
              saveQingdouAsync(
                rowkey?.map((v: any) => {
                  return {
                    ...v,
                    productInfo: getProcuctInfo(v, settings),
                    tenantInventoryReceiptsId: props.detail?.id,
                    totalPrice: 0,
                    targetInventoryLedgerId: "0",
                  };
                })
              )
            ).then(() => {
              // props.Refresh();
              props.onOk();
              setQueries({ count: 20 });
            });
          } else {
            dispatch(
              saveQingdouAsync(
                rowkey?.map((v) => {
                  return {
                    ...v,
                    productInfo: v?.productInfo || getProcuctInfo(v, settings),
                    tenantInventoryReceiptsId: props.detail?.id,
                    targetInventoryLedgerId: v?.targetInventoryLedgerId ||
                      v?.outInvCleanListTargetList[0]?.targetInventoryLedgerId,
                    totalPrice: 0,
                  };
                })
              )
            )
              .then(unwrapResult)
              .then(() => {
                // props.Refresh();
                props.onOk();
                setQueries({ count: 20 });
              })
              .catch((res) => {
                notification.error({
                  message: "请选择装斗或清斗药品",
                  duration: 3,
                });
              });
          }
        }}
      />
      <div
        style={{
          height: '90%',
          background: '#fff',
          borderRadius: '10px',
        }}
      >
        <EditableList
          rowKey={(r) => {
            return (r as any).tenantInventoryLedgerId + size * current;
          }}
          style={{ height: '94%' }}
          page={{
            items: data,
            current: current,
            size: size,
            total: total,
          }}
          onChangePage={(current, pageSize) => {
            setSize(pageSize as number);
            dispatch(setQingdouCurrent(current));
          }}
          columns={
            flag === 1
              ? ModalColumnsOne()
              : ModalColumnsTwo((text, t) => {
                handleChange(t.prev, t.next);
              })
          }
          rowSelection={
            {
              selectedRowKeys: ids,
              onChange: (selectedRowKeys: React.Key[], row: any) => {
                setIds(selectedRowKeys);
                setRowkey(row);
              },
            } as TableRowSelection<any>
          }
          bordered
        />
      </div>
    </Modal>
  );
};
